import { useLanguage } from '../context/LanguageContext';
import { en } from '../translations/en';
import { mr } from '../translations/mr';

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const translations = {
    en,
    mr
  };

  const t = translations[language];

  return { t, language };
};
